






































































































































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import roleMessenger from './role_messenger.vue'
import applyReservoir from './role_reservoir.vue'
import storage from '@/utils/storage'
export default Vue.extend({
    props: ['dataObj'],
    data() {
        return {
            stationShow: false,
            columnsArr: []as any,
            columns: []as any,
            station: '',
            businessId: '',
            currentToken: storage.get('token'),
            imgBaseUrl: config.imgUrl,
            showImg: false,
            showImgObj: {},
            imageList: [] as any,
            instruction: '',
            startTime: '',
            startmm: '0',
            startss: '0',
            endTime: '',
            endmm: '0',
            endss: '0',
            num: '',
            time: '',
            timeShow: false,
            timeShowTag: '',
            minDate: new Date(2019, 0, 1, 0),
            maxDate: new Date(),
            currentDate: new Date(),
            startTimeStr: '',
            endTimeStr: '',
            feedbackType: '',
            disasterShow: false,
            disasterArr: []as any,
            disasterType: '',
        }
    },
    computed: {
        managerInfo(): any {
            return this.$store.state.managerInfo
        },
        areaList(): any[] {
            return this.$store.state.areaList
        },
    },
    created() {
        this.startTime = moment(this.currentDate).format('YYYY-MM-DD HH时')
        this.startTimeStr = moment(this.currentDate).format('YYYYMMDDHH')
        this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH时')
        this.endTimeStr = moment(this.currentDate).format('YYYYMMDDHH')
        this.time = moment(this.currentDate).format('YYYY-MM-DD HH时')
        request.get('/api/farming/rest_rainfall_station/list').then((data) => {
            // console.log(data)
            this.columnsArr = data
            data.map((e: any) => {
                this.columns.push(e.village)
            })
            this.station = this.columns[0]
            this.businessId = this.columnsArr[0].id
        })
    },
    methods: {
        confirmSta(value: any, index: any) {
            this.station = value
            this.businessId = this.columnsArr[index].id
            this.stationShow = false
        },
        cancelSta() {
            this.stationShow = false
        },
        changeType(value: any) {
            this.disasterType = ''
            if (value === '0') {
                this.disasterArr = ['暴雨', '冰雹', '大风', '积雪', '雷暴', '塌方', '泥石流', '山洪']
            } else if (value === '1') {
                this.disasterArr = ['降雨量', '冰雹直径', '积雪深度']
            }
        },
        confirmDisas(value: any, index: any) {
            this.disasterType = value
            this.disasterShow = false
        },
        cancelDisas() {
            this.disasterShow = false
        },
        // 图片 - 上传
        handleSuccess(response: any, file: any, fileList: any) {
            this.$Message.success('上传完成')
            this.imageList.push({
                url: response,
                tag: response.split('.')[1],
            })
        },
        handleError(res: any) {
            console.log(res)
            this.$Message.error('上传失败，请重试')
            alert(res)
        },
        handleFormatError(file: any) {
            this.$Notice.warning({
                title: '文件格式有误',
                desc: '文件' + file.name + '格式有误, 请选择jpg、jpeg、png或mp4、MP4、avi格式文件',
            });
        },
        deletImg(index: any) {
            const arr = JSON.parse(JSON.stringify(this.imageList))
            arr.splice(index, 1)
            this.imageList = arr
        },
        checkImg(item: any) {
            this.showImg = true
            this.showImgObj = item
        },
        closeImg() {
            this.showImg = false
        },
        showTimepicker(timeShow: any, value: any) {
            this.timeShow = timeShow
            this.timeShowTag = value
        },
        confirm() {
            this.timeShow = false
            if (this.timeShowTag === 'start') {
                this.startTime = moment(this.currentDate).format('YYYY-MM-DD HH时')
                this.startTimeStr = moment(this.currentDate).format('YYYYMMDDHH')
            } else if (this.timeShowTag === 'end') {
                this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH时')
                this.endTimeStr = moment(this.currentDate).format('YYYYMMDDHH')
            } else if (this.timeShowTag === 'time') {
                this.time = moment(this.currentDate).format('YYYY-MM-DD HH时')
            }
        },
        cancel() {
            this.timeShow = false
        },
        submit() {
            // if (this.imageList.length < 0) return this.$Message.warning('上传文件不能为空')
            if (!this.feedbackType) {return this.$Message.warning('反馈类型不能为空')}
            if (!this.disasterType) {return this.$Message.warning('反馈类型种类不能为空')}
            if (!this.instruction) {return this.$Message.warning('灾情说明不能为空')}
            if (Number(this.startmm) > 59 || this.startmm.length > 2) {return this.$Message.warning('分不能超过60')}
            // if (Number(this.startss) > 59 || this.startss.length > 2) {return this.$Message.warning('秒不能超过60')}
            if (Number(this.endmm) > 59 || this.endmm.length > 2) {return this.$Message.warning('分不能超过60')}
            // if (Number(this.endss) > 59 || this.endss.length > 2) {return this.$Message.warning('秒不能超过60')}
            const startmm = this.getTimemmss(this.startmm)
            // const startss = this.getTimemmss(this.startss)
            const endmm = this.getTimemmss(this.endmm)
            // const endss = this.getTimemmss(this.endss)
            const start = `${this.startTimeStr}${startmm}00`
            const end = `${this.endTimeStr}${endmm}00`
            // console.log(start)
            // console.log(end)
            if (start > end) {return this.$Message.warning('开始时间不能超过结束时间')}
            if (!this.num) {return this.$Message.warning('雨量值不能为空')}
            if (!this.time) {return this.$Message.warning('观测时间不能为空')}
            const { businessId, imageList, num, instruction, time, feedbackType, disasterType} = this
            const params = {
                businessId,
                imgPaths: imageList.map((e: any) => e.url),
                instruction: this.instruction,
                feedbackValue: num,
                observeTime: moment(this.currentDate).format('YYYY-MM-DD HH:00:00'),
                intro: '',
                timeslot_start: moment(start, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'),
                timeslot_end: moment(end, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'),
                feedbackType: feedbackType === '0' ? '灾情' : feedbackType === '1' ? '气象数据' : '',
                disasterType,
            }
            // console.log(params)
            const url = '/api/farming/rest_disaster_info/rainfall'
            request.post(url, params).then((data) => {
                // console.log(data)
                this.$Message.success('提交成功')
                this.imageList = []
                this.num = ''
                this.instruction = ''
            }).catch((err) => {
                console.log(err)
                this.$Message.warning(err)
            })
        },
        getTimemmss(value: any) {
            return Number(value) > 9 ? Number(value) : '0' + Number(value)
        },
    },
})
